import { actions } from 'react-redux-form';
import { httpGet } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import {
    getInventoryCircuitPlanDetails,
    getInventoryPlanTypesByVendorByCircuitType,
    getInventoryCircuitPlanComponents,
    deleteInventoryCircuitPlanDetails,
    addInventoryCircuitPlanDetails,
    resetInventoryCircuitPlanDetails,
    planDetailsFormModel
} from "../../../../constants/model-reducers/external/inventory/circuit-details/details-view/add-plan-details.settings";

export const planDetailsFormInitialState = planDetailsFormModel;

const defaultState = () => ({
    circuitPlans: [],
    planComponents: DEFAULT_TABLE_RESULT_MODEL,
    planDetails: {
        datatable: []
    }
});

const initialState = defaultState();

export const addPlanDetailActions = {
    getInventoryCircuitPlanDetails: (circuitID) => async (dispatch, state) => {
        var result = await httpGet('external/inventory/getInventoryCircuitPlanDetails/' + circuitID);

        dispatch({
            type: getInventoryCircuitPlanDetails,
            datatable: result.datatable,
        });
    },
    getInventoryPlanTypesByVendorByCircuitType: (vendorId, circuitTypeId) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryPlanByVendorByCircuitType/' + vendorId + '/' + circuitTypeId);
        dispatch({
            type: getInventoryPlanTypesByVendorByCircuitType,
            circuitPlans: res,
        }); 
    },

    getInventoryCircuitPlanComponents: (planId, isOriginalComponent) => async (dispatch, getState) => {
        const { circuitID } = getState().form.inventoryCircuitForm.circuitDetails;

        let planItems;

        if (planId && planId !== 0) {
            try {
                dispatch(actions.change('inventoryCicuitPlanDetailsForm.PlanId', planId));
                if (isOriginalComponent) {
                    planItems = await httpGet(`external/inventory/getInventoryCircuitPlanComponent/${planId}/${circuitID}`);
                } else {
                    planItems = await httpGet(`external/inventory/getInventoryPlanComponentByPlan/${planId}`);
                }

                dispatch({
                    type: getInventoryCircuitPlanComponents,
                    planComponents: Object.keys(planItems).length > 0 ? planItems : DEFAULT_TABLE_RESULT_MODEL,
                });
            } catch (error) {
                // Dispatch an error state in case of failure
                dispatch({
                    type: getInventoryCircuitPlanComponents,
                    planComponents: DEFAULT_TABLE_RESULT_MODEL,
                });
            }
        } else {
            dispatch(actions.change('inventoryCicuitPlanDetailsForm.PlanId', ''));
            dispatch({
                type: getInventoryCircuitPlanComponents,
                planComponents: DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },
    changeFormModel: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value ?? ""));
    },
    deletePlanDetails: () => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitPlanDetails.planDetails;
        dispatch(actions.change('inventoryCicuitPlanDetailsForm.PlanId', 0));
        const newDatatable = [                                                                                                                                                                                                                                                 
            {
                HeaderItem: datatable[0].HeaderItem,
                dataItem: []
            }
        ];

        dispatch({
            type: deleteInventoryCircuitPlanDetails,
            datatable: newDatatable,
        });
    },
    addPlanDetails: () => (dispatch, state) => {
        const { circuitPlans, planDetails, planComponents } = state().inventoryCircuitPlanDetails;
        const { PlanId } = state().form.inventoryCicuitPlanDetailsForm;

        const selectedPlan = circuitPlans.filter(r => r.PlanId == PlanId);
        const totalCost = planComponents?.Data?.Items?.reduce((sum, item) => sum + (item.ComponentCost || 0), 0);
        if (selectedPlan.length > 0) {
            const dataItem = [{
                Currency: null,
                Description: null,
                Monthly: totalCost,
                PlanComponentName: null,
                PlanComponents: null,
                PlanId: PlanId,
                PlanName: selectedPlan[0].PlanName,
                PlanType: null,
                Status: selectedPlan[0].Status,
                TotalCost: 0,
                Year: 0
            }];

            const newDatatable = [
                {
                    HeaderItem: planDetails.datatable[0].HeaderItem,
                    dataItem: dataItem
                }
            ]
            dispatch({
                type: addInventoryCircuitPlanDetails,
                datatable: newDatatable,
            });
        }
    },
    resetPlanDetails: () => (dispatch, state) => {
        dispatch({
            type: resetInventoryCircuitPlanDetails,
            defaultState: defaultState()
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryCircuitPlanDetails:
            return {
                ...state,
                planDetails: {
                    ...state.planDetails,
                    datatable: action.datatable
                }
            }
        case getInventoryPlanTypesByVendorByCircuitType:
            return {
                ...state,
                circuitPlans: action.circuitPlans
            }
        case getInventoryCircuitPlanComponents:
            return {
                ...state,
                planComponents: action.planComponents
            };
        case deleteInventoryCircuitPlanDetails:
            return {
                ...state,
                planDetails: {
                    ...state.planDetails,
                    datatable: action.datatable
                }
            };
        case addInventoryCircuitPlanDetails:
            return {
                ...state,
                planDetails: {
                    ...state.planDetails,
                    datatable: action.datatable
                }
            };
        case resetInventoryCircuitPlanDetails:
            return action.defaultState;
        default:
            return state;
    }
}